import NDAContentModeration from "@/pages/NDAContentModeration";
import SubscriptionManagement from "@/pages/SubscriptionManagement";
import { lazy } from "react";
import { AiOutlineDollarCircle } from "react-icons/ai";
import {
  BsBox,
  BsBriefcase,
  BsChat,
  BsFillBarChartLineFill,
  BsTicket,
} from "react-icons/bs";
import { CgNotes } from "react-icons/cg";
import { GoProjectRoadmap } from "react-icons/go";
import { IoIosBusiness } from "react-icons/io";
import { IoNotifications } from "react-icons/io5";
import { LuUser } from "react-icons/lu";
import { MdOutlineOtherHouses } from "react-icons/md";
import { RxBoxModel, RxDashboard } from "react-icons/rx";
import { TbCategoryPlus, TbMoneybag } from "react-icons/tb";

const Login = lazy(() => import("../pages/Login"));
const UserManagement = lazy(() => import("../pages/UserManagement"));
const DealManagement = lazy(() => import("../pages/DealManagment"));
const Dashboard = lazy(() => import("../pages/Dashboard"));
const ProjectManagement = lazy(() => import("../pages/ProjectManagement"));
const ReportsAnalytics = lazy(() => import("../pages/ReportsAnalytics"));
const EntrepreneurDetail = lazy(() =>
  import("../pages/UserManagement/EntrepreneurDetail")
);
const InvestorDetail = lazy(() =>
  import("../pages/UserManagement/InvestorDetail")
);
const ProjectManagementDetail = lazy(() =>
  import("../pages/ProjectManagement/ProjectManagementDetail")
);
const Chat = lazy(() => import("../pages/Chat"));
const AccountSettings = lazy(() => import("../pages/AccountSettings"));
const SectorInterest = lazy(() => import("../pages/Crud/SectorInterest"));
const BusinessStage = lazy(() => import("../pages/Crud/BusinessStage"));
const TicketSize = lazy(() => import("../pages/Crud/TicketSize"));
const InvestmentFocus = lazy(() => import("../pages/Crud/InvestmentFocus"));
const Ambassadors = lazy(() => import("../pages/Crud/Ambassadors"));

// Projects Cruds
const CapitalUse = lazy(() => import("../pages/Crud/ProjectsCruds/CapitalUse"));
const BusinessModel = lazy(() =>
  import("../pages/Crud/ProjectsCruds/BusinessModel")
);
const PartnershipType = lazy(() =>
  import("../pages/Crud/ProjectsCruds/PartnershipType")
);
const IpType = lazy(() => import("../pages/Crud/ProjectsCruds/IpType"));
const OwnerShip = lazy(() => import("../pages/Crud/ProjectsCruds/OwnerShip"));
const Cms = lazy(() => import("../pages/Cms"));
const Notifications = lazy(() => import("../pages/Notifications"));

export const routes = [
  {
    path: "/login",
    exact: true,
    protected: false,
    showInSidebar: false,
    title: "Login",
    element: <Login />,
  },
  {
    path: "/",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Dashboard",
    icon: <RxDashboard />,
    element: <Dashboard />,
  },
  {
    path: "/user-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "User Management",
    icon: <LuUser />,
    element: <UserManagement />,
  },
  {
    path: "/user-management/entrepreneur/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "User Detail",
    element: <EntrepreneurDetail />,
  },
  {
    path: "/user-management/investor/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Investor Detail",
    element: <InvestorDetail />,
  },
  {
    path: "/deal-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Deal Management",
    icon: <BsBriefcase />,
    element: <DealManagement />,
  },
  {
    path: "/deal-management/chat",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Chat",
    icon: <BsChat />,
    element: <Chat />,
  },
  {
    path: "/project-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Project Management",
    icon: <GoProjectRoadmap />,
    element: <ProjectManagement />,
  },
  {
    path: "/project-management/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Project Management Detail",
    element: <ProjectManagementDetail />,
  },
  {
    path: "/reports-analytics",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Reports Analytics",
    icon: <BsFillBarChartLineFill />,
    element: <ReportsAnalytics />,
  },
  {
    path: "/subscription-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Subscription Management",
    icon: <AiOutlineDollarCircle />,
    element: <SubscriptionManagement />,
  },
  {
    path: "/nda-content-moderation",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "NDA Content Moderation",
    icon: <CgNotes />,
    element: <NDAContentModeration />,
  },

  {
    path: "#",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Crud",
    icon: <BsBox />,
    subMenu: [
      {
        path: "/sector-interest",
        exact: true,
        protected: true,
        showInSidebar: true,
        title: "Sector Interest",
        icon: <BsBox />,
        element: <SectorInterest />,
      },
      {
        path: "/business-stage",
        exact: true,
        protected: true,
        showInSidebar: true,
        title: "Business Stage",
        icon: <IoIosBusiness />,
        element: <BusinessStage />,
      },
      {
        path: "/ticket-size",
        exact: true,
        protected: true,
        showInSidebar: true,
        title: "Ticket Size",
        icon: <BsTicket />,
        element: <TicketSize />,
      },
      {
        path: "/investment-focus",
        exact: true,
        protected: true,
        showInSidebar: true,
        title: "Investment Focus",
        icon: <TbMoneybag />,
        element: <InvestmentFocus />,
      },

      {
        path: "/capital-use",
        exact: true,
        protected: true,
        showInSidebar: true,
        title: "Capital Use",
        icon: <AiOutlineDollarCircle />,
        element: <CapitalUse />,
      },

      {
        path: "/business-model",
        exact: true,
        protected: true,
        showInSidebar: true,
        title: "Business Model",
        icon: <RxBoxModel />,
        element: <BusinessModel />,
      },
      {
        path: "/partnership-type",
        exact: true,
        protected: true,
        showInSidebar: true,
        title: "Partnership Type",
        icon: <MdOutlineOtherHouses />,
        element: <PartnershipType />,
      },
      {
        path: "/ip-type",
        exact: true,
        protected: true,
        showInSidebar: true,
        title: "Ip Type",
        icon: <AiOutlineDollarCircle />,
        element: <IpType />,
      },
      {
        path: "/owner-ship",
        exact: true,
        protected: true,
        showInSidebar: true,
        title: "Owner Ship",
        icon: <AiOutlineDollarCircle />,
        element: <OwnerShip />,
      },
      {
        path: "/ambassadors",
        exact: true,
        protected: true,
        showInSidebar: true,
        title: "Ambassadors",
        icon: <LuUser />,
        element: <Ambassadors />,
      },
    ],
  },

  {
    path: "/account-settings",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Account Settings",
    icon: <LuUser />,
    element: <AccountSettings />,
  },
  {
    path: "/notifications",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Notifications",
    icon: <IoNotifications />,
    element: <Notifications />,
  },
  {
    path: "/cms",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "CMS",
    icon: <TbCategoryPlus />,
    element: <Cms />,
  },
];
